<ng-container *ngFor="let i of numbers">
  &nbsp;
</ng-container>
